<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<!-- Form part : input/display of fields to fill -->
<div [ngSwitch]="contenttype">
    <div *ngSwitchCase="'FORM'">
        <form name="evidenceForm" (ngSubmit)="sendFormData()" novalidate>
            <div class="wl-template-injector evidence-form">
                <div>
                    <!--                    TODO Rewrite forms MTSSIGNBOX-1551-->
                    <!--                    <app-wl-iban-form-->
                    <!--                            [evidenceId]="extevidenceid"-->
                    <!--                            [form]="evidenceForm"-->
                    <!--                            [formController]="form"-->
                    <!--                            [partId]="part.extEvidencePartId"-->
                    <!--                            [type]="evidencetype.type"-->
                    <!--                    ></app-wl-iban-form>-->
                </div>
            </div>
            <div class="k-buttons-bar k-buttons-bar-form">
                <!-- help button -->
                <span>
                    <input class="k-help ic-help" id="form_help_{{num}}-{{numpart}}"
                           title="{{ 'evidences.evidence.help' | translate }}"
                           (click)="openPopoverEvidencePart('help-upload_'+extevidenceid+'-'+part.extEvidencePartId)"
                           [disabled]="partInStandBy"
                           type="button">
                </span>
                <!-- submit button -->
                <span class="custom-send" *ngIf="editMode">
                    <input id="form_submit_{{num}}-{{numpart}}" title="{{ 'evidences.form.send' | translate }}"
                           type="submit"/>
                </span>
                <!-- reset button -->
                <span *ngIf="part.uploadDate">
                    <input id="form_reset_{{num}}-{{numpart}}"
                           title="{{ 'evidences.evidence.remove' | translate }}"
                           [ngClass]="{'k-reset ic-supp': !partInStandBy, 'k-disabled ic-supp': partInStandBy}"
                           (click)="deleteEvidence()" [disabled]="partInStandBy"
                           type="reset"
                           value=""/>
                </span>
                <!-- Edit button -->
                <span *ngIf="((part.uploadDate !== null) && (!editMode))">
                    <input class="k-edit ic-edit" id="form_edit_{{num}}-{{numpart}}" title="{{ 'evidences.form.edit' | translate }}"
                           (click)="edit()"
                           type="button"/>
                </span>
            </div>
        </form>
    </div>
    <div *ngSwitchDefault>
        <dl>
            <dt>
                <!-- Name of part -->
                <!-- Mandatory logo displayed if necessary -->
                <h4 class="part-name"
                    [ngClass]="{'ic-warning': (mandatory && !part.uploadDate)}">
                    <!-- For named parts : name of part -->
                    <span id="title-named_{{num}}-{{numpart}}"
                          *ngIf="contenttype === evidenceContentType.NAMED_PARTS">{{'evidences.type.' + evidencetype.type + '_' + part.partName | translate}}</span>
                    <!-- For multi parts : type + name of part -->
                    <span id="title-multi_{{num}}-{{numpart}}"
                          *ngIf="contenttype === evidenceContentType.MULTI">{{ 'evidences.elementtype.' + part.elementType | translate }} {{ part.partName }}</span>
                    <!-- For single and form part : evidence type -->
                    <span id="title-single_{{num}}-{{numpart}}"
                          *ngIf="contenttype === evidenceContentType.SINGLE">{{ 'evidences.type.' + evidencetype.type | translate }}</span>
                </h4>
                <!-- list of accepted mime types -->
                <span class="format-list" id="accepted-formats_{{num}}-{{numpart}}"
                      *ngIf="!part.uploadDate && !evidenceMsg && part.externalEvidencePartStatus != externalEvidencePartStatus.error && !partUploadInProgress">
                    {{ 'evidences.accepted-format' | translate }}
                    <span class="accepted-format"
                          *ngFor="let mimeType of evidencetype.mimeTypes; let index = index">
                        <span *ngIf="index == (evidencetype.mimeTypes.length -1) && evidencetype.mimeTypes.length>1"> {{ 'evidences.and' | translate }} </span>
                        <span *ngIf="(!(index == 0))&&(!(index == (evidencetype.mimeTypes.length -1)))">, </span>{{mimeType}}
                    </span>
                </span>
                <!-- error msg -->
                <span class="error-form" id="evidence-error" *ngIf="evidenceMsg">{{ evidenceMsg | translate }}</span>
                <span id="file-name_{{num}}-{{numpart}}" *ngIf="part.uploadDate">{{part.fileName}}</span>
                <!-- error msg -->
                <span class="error-form"
                      *ngIf="part.externalEvidencePartStatus == externalEvidencePartStatus.error">{{'evidences.error' | translate }}</span>

                <!-- Buttons : helper, delete, download, upload/sending -->
                <ul class="k-buttons-bar"
                    id="upload">

                    <!-- help button -->
                    <input class="k-help ic-help" id="help_{{num}}-{{numpart}}"
                           title="{{ 'evidences.evidence.help' | translate }}"
                           (click)="openPopoverEvidencePart('help-upload_'+extevidenceid+'-'+part.extEvidencePartId)"
                           [disabled]="partInStandBy"
                           type="button"/>


                    <!-- Single, multi or named part : upload button -->
                    <span [ngClass]="{'custom-file': !partInStandBy, 'custom-file-disabled': partInStandBy,
                                 'custom-file-not-valid': !part.uploadDate, 'custom-file-valid': part.uploadDate}">
                        <input accept="{{inputAcceptedExtension}}" id="upload_{{num}}-{{numpart}}"
                               [name]="'upload-' + part.extEvidencePartId"
                               title="{{ 'evidences.evidence.browse' | translate }}"
                               [disabled]="partInStandBy"
                               type="file"
                               (change)="uploadEvidenceFile($event.target)"/>
                    </span>

                    <!-- Upload/data sending in progress -->
                    <span *ngIf="partUploadInProgress">
                        <input class="k-loader ic-loading"
                               type="button"
                               value="{{ 'evidences.loading' | translate }}"/>
                    </span>

                    <!-- download button -->
                    <li [ngClass]="{'k-download': !partInStandBy, 'ic-dl': !partInStandBy, 'k-disabled': partInStandBy, 'ic-dl-disabled': partInStandBy}"
                        *ngIf="(part.uploadDate) && (contenttype !== evidenceContentType.FORM)">
                        <a id="download_{{num}}-{{numpart}}" title="{{ 'evidences.evidence.download' | translate }}"
                           (click)="download(part, imageUploaded)"
                           *ngIf="!partInStandBy"></a>
                    </li>

                    <!-- reset button -->
                    <span *ngIf="part.uploadDate">
                        <input id="reset_{{num}}-{{numpart}}"
                               title="{{ 'evidences.evidence.remove' | translate }}"
                               [ngClass]="{'k-reset': !partInStandBy, 'k-disabled': partInStandBy, 'ic-supp': true}" (click)="deleteEvidence()"
                               [disabled]="partInStandBy"
                               type="reset" value=""/>
                    </span>
                </ul>
            </dt>
        </dl>

    </div>
</div>


<!-- Helper popup -->
<span *ngIf=" rootScope.get().popoverTable['help-upload_'+extevidenceid+'-'+part.extEvidencePartId]">
    <app-wl-popover
            id="{{'popover-help-upload_'+extevidenceid+'-'+part.extEvidencePartId}}"
            [popoverId]="'popover-help-upload_'+extevidenceid+'-'+part.extEvidencePartId"
            [evidencestate]="popoverMode.uploadEvidencePart"
            [buttonid]="null"
            [partname]="part.partName"
            [evidencetype]="evidencetype"
            [contenttype]="contenttype">
    </app-wl-popover>
</span>